import checkCircle from "@assets/images/check-circle.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import InlineSVG from "react-inlinesvg";

import useStyles from "./styles";

interface DialogAddMatSuccess {
  onClose: () => void;
  open: boolean;
  title?: string;
}

const DialogAddMatSuccess: React.FC<DialogAddMatSuccess> = ({
  onClose,
  open,
  title = "เพิ่มข้อมูลสำเร็จ"
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} className={classes.root} fullWidth maxWidth="xs">
      <DialogContent className={classes.dialogContent}>
        <InlineSVG src={checkCircle} width={40} height={40} />
        <p className={classes.titleHeader}>{title}</p>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          className={classes.btnAction}
        >
          <MyTypography variant="button" className={classes.textBtn}>
            ดำเนินการต่อ
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogAddMatSuccess;
